import type { ApiResponse } from '@api/types/api-response';
import api from '.';
import {
  ROUTE as GET_STATS_ROUTE,
  Params as GetStatsParams,
  Result as GetStatsResult,
} from '@api/routes/stats/get/params';

export const stats = api.injectEndpoints({
  endpoints: builder => ({
    getGlobalStats: builder.query<ApiResponse<GetStatsResult>, GetStatsParams>({
      query: () => ({
        method: 'GET',
        url: GET_STATS_ROUTE,
      }),
    }),
  }),
  overrideExisting: false,
});
